import axiosNextGen from '../../../config/axios-nextgen';

/**
 * @param {{ selectedFacilities: string[], selectedRecallTypes: string[], returnStatuses: string[], ianaTimezone: string }} request
 * @returns {Promise<Blob>}
 */
export async function getRecallCallListReport(request) {
    const response = await axiosNextGen.post('/api/reports/recall-call-list', request, { responseType: 'blob' });
    return response.data;
}

/**
 * @param {{ selectedFacilities: string[], selectedRecallTypes: string[], returnStatuses: string[], ianaTimezone: string }} request
 * @returns {Promise<Array>}
 */
export async function getRecallCallListData(request) {
    const response = await axiosNextGen.post('/api/reports/recall-call-list/data', request);
    return response.data;
}
